import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { TranslocoDirective } from '@jsverse/transloco';

/**
 * Navigation sidebar header component.
 * Shows logo and app title, hides title when collapsed.
 */
@Component({
  selector: 'app-nav-header',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoDirective],
  template: `
    <div class="nav-header" *transloco="let t">
      <img class="nav-logo" [src]="logoSrc()" [attr.alt]="t('navigation.logo')" />
      @if (!collapsed()) {
        <span class="nav-title">{{ t('navigation.appName') }}</span>
      }
    </div>
  `,
})
export class NavHeaderComponent {
  /** Whether the sidebar is collapsed */
  readonly collapsed = input.required<boolean>();

  /* DIVERGENCE LOCALE BackStage — voir ../../PROVENANCE.md. Le chemin du logo
     etait fige sur celui du Manager. Devenu une ENTREE, valeur par defaut
     identique : sans liaison, le rendu est celui de la source. */
  readonly logoSrc = input<string>('assets/Tick&LiveManager.png');
}
